module.exports = __webpack_public_path__ + "static/media/IconTemplates_-51.891186ab.svg";